module.exports = {
  PlaidAndFlinksEvents: {
    AddBankAccountConsentIntercept: {
      code: 'ConsentIntercept',
      events: {
        ConsentInterceptLoad: {
          description: 'Triggers when the consent intercept is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: '[$.bankProvider] Intercept_Page Loaded'
          }
        },
        ConsentInterceptCtaClick: {
          description:
            'Triggers when the consent intercept CTA button is clicked.',
          eventHub: {
            code: 'OnCtaClick',
            action: '[$.bankProvider] Intercept_Link Account Clicked'
          }
        }
      }
    }
  }
};
